import { render, staticRenderFns } from "./Green.vue?vue&type=template&id=57c4636f&scoped=true&"
import script from "./Green.vue?vue&type=script&lang=ts&"
export * from "./Green.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c4636f",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57c4636f')) {
      api.createRecord('57c4636f', component.options)
    } else {
      api.reload('57c4636f', component.options)
    }
    module.hot.accept("./Green.vue?vue&type=template&id=57c4636f&scoped=true&", function () {
      api.rerender('57c4636f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/analytics/Green.vue"
export default component.exports